import { render, staticRenderFns } from "./EstimateRegister.vue?vue&type=template&id=0510ceda&scoped=true&"
import script from "./EstimateRegister.vue?vue&type=script&lang=ts&"
export * from "./EstimateRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0510ceda",
  null
  
)

export default component.exports